import { createFileRoute } from "@tanstack/react-router";
import { formatPageIdentifier, pageHead } from "../../../utils/page-title";

export const Route = createFileRoute("/compatibility/$firstUsername/$secondUsername")({
  head: ({ params }) => ({
    ...pageHead(
      `${formatPageIdentifier(params.firstUsername)} & ${formatPageIdentifier(params.secondUsername)}`,
      {
        canonicalPath: `/compatibility/${params.firstUsername}/${params.secondUsername}`,
        robots: "noindex, nofollow",
      },
    ),
  }),
});
